import { render } from "./BaseContainer.vue?vue&type=template&id=c466e66e&scoped=true"
import script from "./BaseContainer.vue?vue&type=script&lang=js"
export * from "./BaseContainer.vue?vue&type=script&lang=js"

import "./BaseContainer.vue?vue&type=style&index=0&id=c466e66e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-c466e66e"

export default script